import LeaderboardTable, {
  configOptions as leaderboardConfigOptions,
  icon as leaderboardIcon,
} from '../components/dashboardModules/LeaderboardTable'

import TasksCompletedPerDatePeriodChart, {
  configOptions as tasksCompletedPerDatePeriodConfigOptions,
  icon as tasksCompletedPerDatePeriodIcon,
} from '../components/dashboardModules/TasksCompletedPerDatePeriodChart'

import WeeklyWorkloadChart, {
  configOptions as weeklyWorkloadConfigOptions,
  icon as weeklyWorkloadIcon,
} from '../components/dashboardModules/WeeklyWorkloadChart'

export const generateAvailableModules = () => ({
  Leaderboard: {
    component: LeaderboardTable,
    configOptions: leaderboardConfigOptions(),
    icon: leaderboardIcon,
    id: 'Leaderboard',
    title: 'Task Accuracy Leaderboard',
  },
  TasksCompletedPerDatePeriodChart: {
    component: TasksCompletedPerDatePeriodChart,
    configOptions: tasksCompletedPerDatePeriodConfigOptions(),
    icon: tasksCompletedPerDatePeriodIcon,
    id: 'TasksCompletedPerDatePeriodChart',
    title: 'Tasks Completed per Period',
  },
  WeeklyWorkloadChart: {
    component: WeeklyWorkloadChart,
    configOptions: weeklyWorkloadConfigOptions(),
    icon: weeklyWorkloadIcon,
    id: 'WeeklyWorkloadChart',
    title: 'Future Weekly Workload',
  },
})

export const dashboardDefaultLayout = {
  columns: {
    main: {
      id: 'main',
      modules: [
        {
          key: 'Leaderboard-1',
          moduleId: 'Leaderboard',
        },
        {
          key: 'WeeklyWorkloadChart-1',
          moduleId: 'WeeklyWorkloadChart',
        },
        {
          key: 'TasksCompletedPerDatePeriodChart-1',
          moduleId: 'TasksCompletedPerDatePeriodChart',
        },
      ],
    },
    sidebar: {
      id: 'sidebar',
      modules: [],
    },
  },
  custom: false,
  options: {
    'Leaderboard-1': {
      customization: {
        title: 'Task Accuracy Leaderboard',
      },
      queryParams: {
        month: 'current_month',
        limit: 25,
      },
    },
    'TasksCompletedPerDatePeriodChart-1': {
      queryParams: {
        date_period: 'month',
        date_range: '12_months',
      },
    },
    'WeeklyWorkloadChart-1': {
      queryParams: {
        date_range: '3_months',
      },
    },
  },
}
